module.exports = __webpack_public_path__ + "img/hazard-concrete-right.ae52673b.png";